module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Maggie Moor is the author of "), _c('em', [_vm._v("I Am: Your Guide to Mind and Body Union for Total Awareness")]), _vm._v(", and her psychoanalytic paper, "), _c('em', [_vm._v("Coloring Outside the Lines: Sadomasochistic Defense and the Search for Identity,")]), _vm._v(" was nominated for the NAAP Gradiva Award. She lives in New York City, where she is a licensed psychoanalyst and works with people recovering from trauma and addiction. Maggie is also a three-time national figure competitor and a jazz-rock singer/songwriter. She has recorded three albums with Grammy-award-winning musicians. "), _c('em', [_vm._v("Skinless: The Story of a Female Survivor")]), _vm._v(" is Maggie Moor’s first fiction novel.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0